module.exports = __webpack_public_path__ + "img/9.898ac12f.png";